import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../../core/services/data.service';
import { UserLinkProviderService } from '../link-provider.service';

@Injectable({
    providedIn: 'root'
})
export class TokenValidationResolver  {

    constructor(
        private dataService: DataService,
        private userLinks: UserLinkProviderService
    ) { }

    async resolve(activatedRoute: ActivatedRouteSnapshot, _snap: RouterStateSnapshot): Promise<boolean> {
        const token = activatedRoute.params[this.userLinks.activateIdParam];
        return this.dataService.verifyEmail(String(token)).toPromise().then(
            t => t ?? false,
            () => false)
            .catch(
                () => false);
    }
}
